<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCheckplusDecodedData } from "@/api/niceApi.js";

export default {
  name: "CheckplusSuccess",
  computed: {
    ...mapGetters(["bizInfo"]),
  },
  created() {
    const urlParams = new URLSearchParams(location.search);
    const encodeData = urlParams.get("EncodeData");
    (async function () {
      getCheckplusDecodedData({ encodeData }).then(response => {
        window.opener.document.getElementById("certifiedName").value = response.name;
        window.opener.document.getElementById("certifiedTel").value = response.mobileNo;
        window.close();
      });
    })();
  },
};
</script>
